<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <default-select v-model="applicationPort"
          input-label="Порт"
          input-name="port"
          :options="portsList"
          :errors="errors"
        />
      </div>
      <div class="col-md-4">
        <default-select v-model="applicationDirection"
          input-label="Направление"
          input-name="direction"
          :options="[{id:1, name:'Заход в акваторию'},{id:2, name:'Выход из акватории'}]"
          :errors="errors"
        />
      </div>
      <div class="col-md-4">
        <default-input input-label="Плановая дата"
          input-name="planed_date"
          v-slot="{id}"
          :errors="errors"
        >
          <date-picker
            v-model="applicationDate"
            v-facade="'##.##.####'"
            format="DD.MM.YYYY"
            :id="id"
            :value-type="'format'"
            :disabled="disabledInput"
            :disabled-date="disabledDate"
          />
        </default-input>
      </div>
      <div class="col-md-4">
        <default-select v-model="applicationSailType"
          input-label="Тип плавания"
          input-name="sail_type"
          :options="sailTypeList"
          :errors="errors"
        />
      </div>
      <div class="col-md-4">
        <default-select input-label="Cудно"
          input-name="name"
          :group="'vessels'"
          :errors="errors"
          v-slot="{selectID}"
        >
          <v-select
            v-if="isNewVessel === false"
            :id="selectID"
            :filter="fuseSearch"
            label="name"
            v-model="vesselModel"
            item-text="name"
            :options="vesselsList"
            :disabled="disabledInput"
            :clearable="true"
            @search="searchText = $event"
            @search:blur="vesselName = searchText; searchText = ''"
            @option:selected="searchText = $event.name"
          >
            <div slot="no-options">
              <a @click.prevent="setIsNewVessel(true)" href="#" style="text-decoration: underline">Добавить судно</a>
            </div>
            <template #open-indicator="{ attributes }">
              <svg width="14" height="8" xmlns="http://www.w3.org/2000/svg" v-bind="attributes">
                <path stroke="null" id="svg_1" d="m10.838366,0.093268l-4.59,4.58l-4.59,-4.58l-1.41,1.41l6,6l6,-6l-1.41,-1.41z"/>
              </svg>
            </template>
          </v-select>
          <template v-else>
            <input v-model="vesselName" id="vessel-input" class="form-control form-group">
            <a
              v-if="isNewVessel && !isCheck && !isView"
              @click="setIsNewVessel(false); clearVesselFields()"
              class="transport-owner-helpers"
            >{{ 'Выбрать из справочника' }}</a>
          </template>
        </default-select>
      </div>
      <div class="col-md-4">
        <default-input v-model.trim="vesselVolume"
          input-label="Валовая вместимость, т"
          input-name="tonnage"
          :group="'vessels'"
          :errors="errors"
          :disabled="isNewVessel === false"
          @change="vesselVolume = $event"
        >
        </default-input>
      </div>
    </div>
    <div class="row documents" v-if="isNewVessel">
      <vessel-documents-form-block
        v-model="vessel"
        :vessel-documents="requiredDocuments"
        :errors="errors"
      >
      </vessel-documents-form-block>
    </div>
  </div>
</template>

<script>
import DefaultSelect from '@/components/application/form-inputs/DefaultSelect';
import DefaultInput from '@/components/application/form-inputs/DefaultInput';
import VSelect from 'vue-select';
import VesselDocumentsFormBlock from '@/components/application/form-blocks/vessels/VesselDocumentsFormBlock';
import { mapMutations, mapState } from 'vuex';
import applicationFormMixin from '@/common/mixins/applicationFormMixin';
import applicationInputMixin from '@/common/mixins/applicationInputMixin';
import moment from 'moment';
import VesselClient from '@/common/helpers/api-client/Vessel';
import Fuse from 'fuse.js';

export default {
  name: 'PortCallFormBlock',

  components: {
    DefaultInput,
    DefaultSelect,
    VSelect,
    VesselDocumentsFormBlock
  },

  mixins: [
    applicationFormMixin,
    applicationInputMixin
  ],

  data () {
    return {
      searchText: '',
      requiredDocuments: []
    }
  },

  computed: {
    ...mapState('vtsApplication', {
      application: state => state.application,
      vessel: state => state.vessel,
      vesselsList: state => state.vesselsList,
      portsList: state => state.portsList,
      sailTypeList: state => state.sailTypeList,
      isNewVessel: state => state.isNewVessel
    }),

    applicationDate: {
      get () {
        return this.application.planed_date
      },

      set (planed_date) {
        this.setApplication({ planed_date })
      }
    },

    applicationDirection: {
      get () {
        return this.application.direction
      },

      set (direction) {
        this.setApplication({ direction })
      }
    },

    applicationPort: {
      get () {
        return this.application.port
      },

      set (port) {
        this.setApplication({ port })
      }
    },

    applicationSailType: {
      get () {
        return this.application.sail_type
      },

      set (sail_type) {
        this.setApplication({ sail_type })
      }
    },

    vesselModel: {
      get () {
        return this.vessel
      },

      set (vessel) {
        this.setVessel(vessel)
      }
    },

    vesselName: {
      get () {
        return this.vessel.name;
      },

      set (name) {
        this.setVesselName(name)
      }
    },

    vesselVolume: {
      get () {
        return this.vessel.tonnage
      },

      set (tonnage) {
        tonnage = tonnage?.replace(/,/g, '.')
        tonnage = tonnage?.replace(/[^.,\d]/g, '')

        const match = tonnage?.match(/\d+\.?\d{0,2}/)
        if (match && match[0]) {
          tonnage = match[0]
        }

        this.setVesselVolume(tonnage)
      }
    }
  },

  async created () {
    this.requiredDocuments = await VesselClient.requiredDocuments()
  },

  methods: {
    ...mapMutations('vtsApplication', [
      'setVessel',
      'setIsNewVessel',
      'setApplication',
      'clearVessel'
    ]),

    fuseSearch (options, search) {
      const fuse = new Fuse(options, {
        keys: ['name', 'alternate_name'],
        shouldSort: true
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },

    clearVesselFields () {
      this.clearVessel()
    },

    disabledDate (date) {
      return this.isEdit ? false : date < moment().add(-1, 'days')
    },

    setVesselName (name) {
      this.setVessel({ name })
    },

    setVesselVolume (tonnage) {
      this.setVessel({ tonnage })
    }
  }
}
</script>
